/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { ReactNode, useRef, useState } from "react";
import {
  TouchableOpacity,
  View,
  Animated,
  StyleProp,
  ViewStyle,
} from "react-native";
import Icon from "react-icons-kit";
import { chevronDown } from "react-icons-kit/feather/chevronDown";
import { chevronRight } from "react-icons-kit/feather/chevronRight";

import { skaleBlack } from "config/UpduoColors";

export default function Accordion({
  head,
  body,
  chevronColor = skaleBlack,
  style,
}: {
  head: ReactNode;
  body: ReactNode;
  chevronColor?: string;
  style?: StyleProp<ViewStyle>;
}) {
  const [hidden, setHidden] = useState(true);
  const maxHeight = useRef(0);
  const animatedHeight = useRef(new Animated.Value(0)).current;

  const _handleToggleShowBody = () => {
    setHidden((wasHidden) => {
      const hidden = !wasHidden;
      const targetHeight = hidden ? 0 : maxHeight.current;
      Animated.timing(animatedHeight, {
        toValue: targetHeight,
        duration: 300,
        useNativeDriver: true,
      }).start();
      return hidden;
    });
  };

  return (
    <View style={style}>
      <TouchableOpacity
        onPress={_handleToggleShowBody}
        style={{ flexDirection: "row", alignItems: "center" }}
      >
        <div style={{ color: chevronColor }}>
          <Icon
            icon={hidden ? chevronRight : chevronDown}
            style={{ marginTop: 4, marginBottom: 4, marginRight: 8 }}
            size={25}
          />
        </div>
        {head}
      </TouchableOpacity>
      <Animated.View
        style={[{ overflow: "hidden" }, { height: animatedHeight }]}
      >
        <View
          onLayout={(event) => {
            maxHeight.current = event.nativeEvent.layout.height;
          }}
        >
          {body}
        </View>
      </Animated.View>
    </View>
  );
}
